<template>
  <div class="card mb-2">
    <div
        class="card-header d-flex justify-content-between align-items-center gap-3"
        role="button"
        @click="$emit('toggle')"
    >
      <div>
        <span class="fw-bold text-capitalize-first">{{ title }}</span>
        <small v-if="subtitle" class="d-block text-muted">{{ subtitle }}</small>
      </div>
      <div class="d-flex align-items-center gap-3">
        <div v-if="$slots.actions" @click.stop>
          <slot name="actions"></slot>
        </div>
        <span class="text-muted small text-nowrap">
          <template v-if="count !== null">{{ count }}</template>
          <i class="fa ms-2" :class="open ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </span>
      </div>
    </div>
    <div v-show="open" class="card-body">
      <slot></slot>
    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent, PropType} from 'vue'

export default defineComponent({
  name: 'CollapsibleCard',
  props: {
    title: {type: String, required: true},
    subtitle: {type: String, default: ''},
    count: {type: Number as PropType<number | null>, default: null},
    open: {type: Boolean, required: true},
  },
  emits: ['toggle'],
})
</script>
